var _defs, _tspan;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNumFaultComparison(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 367.735,
    height: 310,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h298.96v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-44.54 27.366h360v-288h-360Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h298.96v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-76.532 27.366h360v-288h-360Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h298.96v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-111.704 27.366h360v-288h-360Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h298.96v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-146.876 27.366h360v-288h-360Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h298.96v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-182.048 27.366h360v-288h-360Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h298.96v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-217.22 27.366h360v-288h-360Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h298.96v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-252.391 27.366h360v-288h-360Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h298.96v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-287.563 27.366h360v-288h-360Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h298.96v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "A",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-322.735 27.366h360v-288h-360Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "C",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-148.903 13.694h360v-288h-360Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "D",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h298.96v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "E",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "F",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24.814 38.163h360v-288h-360Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "G",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h298.96v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "H",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "I",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24.814 80.476h360v-288h-360Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "J",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h298.96v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "K",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "L",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24.814 122.789h360v-288h-360Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "M",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h298.96v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "N",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "O",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24.814 165.101h360v-288h-360Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "P",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h298.96v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Q",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "R",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24.814 207.414h360v-288h-360Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "S",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h298.96v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "T",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "U",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24.814 249.727h360v-288h-360Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "V",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-109.797-18.736v360h288v-360Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "X",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "W",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Z",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Y",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "af",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ah",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ag",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aj",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ai",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "al",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ak",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "an",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "am",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ap",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ao",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ar",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aq",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "at",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "as",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "av",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "au",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ax",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aw",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "az",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ay",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aB",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aA",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aD",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aC",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aF",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aE",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aH",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aG",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aJ",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aL",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aK",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aN",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aM",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aP",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aO",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aR",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aQ",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aT",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aS",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aV",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aU",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aX",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aW",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aZ",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aY",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bb",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bd",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bc",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bf",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "be",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bh",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bg",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bj",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bi",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bl",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bk",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bn",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bm",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bp",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bo",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "br",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bq",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bt",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bs",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bv",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bu",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bx",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bw",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bz",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "by",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bB",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h4v4h-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bA",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9461.991 579.273h327.254V324.528H9461.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bC",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h298.96v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bD",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h298.96v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bE",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h298.96v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bF",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h298.96v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bG",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h298.96v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bH",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h298.96v232.72H47.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bI",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bJ",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bK",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bL",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bM",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bN",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-308.267 256.286h360v-288h-360Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bO",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bP",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-320.599 239.083h360v-288h-360Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bQ",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bR",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-320.599 221.458h360v-288h-360Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bS",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bT",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-320.599 203.833h360v-288h-360Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bU",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bV",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-320.599 186.208h360v-288h-360Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bW",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bX",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-320.599 168.583h360v-288h-360Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bY",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v288H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bZ",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-320.599 150.958h360v-288h-360Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9421.796 613.163h368.894v-290.08h-368.894Z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(-9421.838 -309.368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96v232.72",
    clipPath: "url(#b)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96v-3.5",
    clipPath: "url(#c)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#d)",
    transform: "translate(9458.51 595.248)scale(1.09464)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "0")), /*#__PURE__*/React.createElement("path", {
    d: "M82.892 41.96v232.72",
    clipPath: "url(#e)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.892 41.96v-3.5",
    clipPath: "url(#f)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#g)",
    transform: "translate(9493.53 595.248)scale(1.09464)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3600001",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "10")), /*#__PURE__*/React.createElement("path", {
    d: "M118.064 41.96v232.72",
    clipPath: "url(#h)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.064 41.96v-3.5",
    clipPath: "url(#i)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#j)",
    transform: "translate(9532.03 595.248)scale(1.09464)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3600001",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "20")), /*#__PURE__*/React.createElement("path", {
    d: "M153.235 41.96v232.72",
    clipPath: "url(#k)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.235 41.96v-3.5",
    clipPath: "url(#l)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#m)",
    transform: "translate(9570.531 595.248)scale(1.09464)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3600001",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "30")), /*#__PURE__*/React.createElement("path", {
    d: "M188.407 41.96v232.72",
    clipPath: "url(#n)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.407 41.96v-3.5",
    clipPath: "url(#o)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#p)",
    transform: "translate(9609.032 595.248)scale(1.09464)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3600001",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "40")), /*#__PURE__*/React.createElement("path", {
    d: "M223.579 41.96v232.72",
    clipPath: "url(#q)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.579 41.96v-3.5",
    clipPath: "url(#r)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#s)",
    transform: "translate(9647.532 595.248)scale(1.09464)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3600001",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "50")), /*#__PURE__*/React.createElement("path", {
    d: "M258.75 41.96v232.72",
    clipPath: "url(#t)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.75 41.96v-3.5",
    clipPath: "url(#u)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#v)",
    transform: "translate(9686.032 595.248)scale(1.09464)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3600001",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "60")), /*#__PURE__*/React.createElement("path", {
    d: "M293.922 41.96v232.72",
    clipPath: "url(#w)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.922 41.96v-3.5",
    clipPath: "url(#x)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#y)",
    transform: "translate(9724.533 595.248)scale(1.09464)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3600001",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "70")), /*#__PURE__*/React.createElement("path", {
    d: "M329.094 41.96v232.72",
    clipPath: "url(#z)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.094 41.96v-3.5",
    clipPath: "url(#A)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#B)",
    transform: "translate(9763.033 595.248)scale(1.09464)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3600001",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "80")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#C)",
    transform: "translate(9572.75 610.213)scale(1.09464)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 5.75 11.87 15.98 22.33 28.48 32.59 38.509998 41.689999 47.82 51.740002 55.66 61.810001 71.550003 77.900002 81.82 87.029999 90.209999",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "Forgery attempts p")), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h298.96",
    clipPath: "url(#D)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h-3.5",
    clipPath: "url(#E)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#F)",
    transform: "translate(9436.917 583.429)scale(1.09464)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3600001 9.54",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "0.0")), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 84.273h298.96",
    clipPath: "url(#G)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 84.273h-3.5",
    clipPath: "url(#H)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#I)",
    transform: "translate(9436.917 537.112)scale(1.09464)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3600001 9.54",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "0.2")), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 126.585h298.96",
    clipPath: "url(#J)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 126.585h-3.5",
    clipPath: "url(#K)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#L)",
    transform: "translate(9436.917 490.794)scale(1.09464)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3600001 9.54",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "0.4")), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 168.898h298.96",
    clipPath: "url(#M)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 168.898h-3.5",
    clipPath: "url(#N)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#O)",
    transform: "translate(9436.917 444.477)scale(1.09464)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3600001 9.54",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "0.6")), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 211.21h298.96",
    clipPath: "url(#P)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 211.21h-3.5",
    clipPath: "url(#Q)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#R)",
    transform: "translate(9436.917 398.16)scale(1.09464)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3600001 9.54",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "0.8")), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 253.524h298.96",
    clipPath: "url(#S)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 253.524h-3.5",
    clipPath: "url(#T)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#U)",
    transform: "translate(9436.917 351.843)scale(1.09464)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3600001 9.54",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "1.0")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#V)",
    transform: "rotate(-90 4967.64 -4462.624)scale(1.09464)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.3499999 12.69 18.190001 23.690001 29.84 35.049999 40.259998 43.439999 49.790001 53.900002 60.02 66.370003 72.5 78.849998 81.629997 84.410004 87.190002 91.110001",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "Success probability")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#W)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#X)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9465.841 577.177)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Y)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#Z)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9469.691 577.177)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#ab)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9477.391 572.957)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ac)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#ad)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9492.791 566.64)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#af)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9523.592 552.956)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ag)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#ah)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9585.192 530.85)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#aj)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9708.394 498.218)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ak)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#al)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9465.841 573.731)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#am)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#an)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9469.691 568.516)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ao)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#ap)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9477.391 560.857)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aq)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#ar)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9492.791 540.159)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#as)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#at)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9523.592 513.431)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#au)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#av)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9585.192 463.48)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aw)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#ax)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9708.394 421.24)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ay)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#az)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9465.841 551.221)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aA)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#aB)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9469.691 531.161)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aC)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#aD)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9477.391 495.282)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aE)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#aF)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9492.791 438.2)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aG)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#aH)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9523.592 388.948)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#aJ)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9585.192 363.18)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aK)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#aL)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9708.394 350.622)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aM)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#aN)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9465.841 522.502)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aO)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#aP)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9469.691 477.954)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aQ)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#aR)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9477.391 430.35)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aS)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#aT)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9492.791 380.816)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aU)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#aV)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9523.592 352.994)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aW)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#aX)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9585.192 348.008)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aY)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#aZ)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9708.394 347.847)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ba)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#bb)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9465.841 455.438)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bc)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#bd)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9469.691 401.723)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#be)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#bf)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9477.391 362.482)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bg)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#bh)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9492.791 350.099)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bi)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#bj)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9523.592 347.687)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bk)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#bl)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9585.192 347.687)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bm)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#bn)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9708.394 347.687)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bo)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#bp)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9465.841 379.069)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bq)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#br)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9469.691 354.773)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bs)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#bt)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9477.391 348.17)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bu)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#bv)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9492.791 347.687)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bw)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#bx)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9523.592 347.687)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#by)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#bz)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9585.192 347.687)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bA)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    clipPath: "url(#bB)",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "gray",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9708.394 347.687)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.237 43.875h3.517l7.035 3.855 14.068 5.77L103.995 66l56.275 20.195 112.55 29.811",
    clipPath: "url(#bC)",
    style: {
      fill: "none",
      stroke: "#1f77b4",
      strokeWidth: 1.5,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.237 47.022 3.517 4.764 7.035 6.998 14.068 18.908 28.138 24.417 56.275 45.633 112.55 38.588",
    clipPath: "url(#bD)",
    style: {
      fill: "none",
      stroke: "#ff7f0e",
      strokeWidth: 1.5,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.237 67.586 3.517 18.326 7.035 32.777 14.068 52.146 28.138 44.995 56.275 23.54 112.55 11.472",
    clipPath: "url(#bE)",
    style: {
      fill: "none",
      stroke: "#2ca02c",
      strokeWidth: 1.5,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.237 93.822 3.517 40.697 7.035 43.488 14.068 45.251 28.138 25.417 56.275 4.555 112.55.147",
    clipPath: "url(#bF)",
    style: {
      fill: "none",
      stroke: "#d62728",
      strokeWidth: 1.5,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.237 155.088 3.517 49.07 7.035 35.85 14.068 11.312 28.138 2.204H272.82",
    clipPath: "url(#bG)",
    style: {
      fill: "none",
      stroke: "#9467bd",
      strokeWidth: 1.5,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.237 224.854 3.517 22.196 7.035 6.032 14.068.442H272.82",
    clipPath: "url(#bH)",
    style: {
      fill: "none",
      stroke: "#8c564b",
      strokeWidth: 1.5,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96v232.72",
    clipPath: "url(#bI)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.68 41.96v232.72",
    clipPath: "url(#bJ)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 41.96h298.96",
    clipPath: "url(#bK)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 274.68h298.96",
    clipPath: "url(#bL)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.599 143.658h53.681q2.4 0 2.4 2.4V266.28q0 2.4-2.4 2.4h-53.681q-2.4 0-2.4-2.4V146.058q0-2.4 2.4-2.4z",
    clipPath: "url(#bM)",
    style: {
      fill: "#fff",
      fillOpacity: 0.8,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 0.8
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#bN)",
    transform: "translate(9747.197 344.663)scale(1.09464)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 10,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "q")), /*#__PURE__*/React.createElement("path", {
    d: "M286.999 243.283h24",
    clipPath: "url(#bO)",
    style: {
      fill: "none",
      stroke: "#1f77b4",
      strokeWidth: 1.5,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#bP)",
    transform: "translate(9760.695 363.494)scale(1.09464)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 12,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "8")), /*#__PURE__*/React.createElement("path", {
    d: "M286.999 225.658h24",
    clipPath: "url(#bQ)",
    style: {
      fill: "none",
      stroke: "#ff7f0e",
      strokeWidth: 1.5,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#bR)",
    transform: "translate(9760.695 382.787)scale(1.09464)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 7.632",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 12,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "10")), /*#__PURE__*/React.createElement("path", {
    d: "M286.999 208.033h24",
    clipPath: "url(#bS)",
    style: {
      fill: "none",
      stroke: "#2ca02c",
      strokeWidth: 1.5,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#bT)",
    transform: "translate(9760.695 402.08)scale(1.09464)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 7.632",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 12,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "15")), /*#__PURE__*/React.createElement("path", {
    d: "M286.999 190.408h24",
    clipPath: "url(#bU)",
    style: {
      fill: "none",
      stroke: "#d62728",
      strokeWidth: 1.5,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#bV)",
    transform: "translate(9760.695 421.373)scale(1.09464)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 7.632",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 12,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "20")), /*#__PURE__*/React.createElement("path", {
    d: "M286.999 172.783h24",
    clipPath: "url(#bW)",
    style: {
      fill: "none",
      stroke: "#9467bd",
      strokeWidth: 1.5,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#bX)",
    transform: "translate(9760.695 440.666)scale(1.09464)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 7.632",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 12,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "30")), /*#__PURE__*/React.createElement("path", {
    d: "M286.999 155.158h24",
    clipPath: "url(#bY)",
    style: {
      fill: "none",
      stroke: "#8c564b",
      strokeWidth: 1.5,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.09464 0 0 -1.09464 9409.755 625.204)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    clipPath: "url(#bZ)",
    transform: "translate(9760.695 459.959)scale(1.09464)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 7.632",
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: 12,
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "50"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 39.43,
    y: 10.794,
    style: {
      fill: "#000"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 39.43,
    y: 10.794
  }, "SPHINCS Attack Performance"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumFaultComparison);
export default __webpack_public_path__ + "static/media/numFaultComparison.45e9e999dcafbcb1342bb2dedeb09869.svg";
export { ForwardRef as ReactComponent };